import * as form from '../form';

export const legalAssociationsHateCrimeAdvocacy = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Why: form.textarea(xitem.Why),
        When: form.daterange(xitem.When),
        What: form.textarea(xitem.What),
      },
    };
  });
  return {
    HasHateCrimeAdvocacy: form.branch(data.HasHateCrimeAdvocacy),
    List: form.collection(items, (data.List || {}).branch),
  };
};
